<div class="content-loaf">
  <h2>動画視聴</h2>
  <hr />

  <div class="row content-block">
    <div class="col-12" *ngIf="urlInfo.url.length > 0">
      <p>ボタンをクリックすると佐伯地区医師会の動画を視聴できます。</p>

      <a name="saiki-tube-link" class="btn btn-primary btn-primary-gradient layout-btn" href="{{urlInfo.url}}" target="_blank">視聴する</a>
    </div>

    <div class="col-12" *ngIf="urlInfo.url.length == 0">
      <p>現在、視聴可能な動画はありません。</p>
    </div>
  </div>
</div>
